<!-- Left Hand Side -->
<div class="col-sm-3" id="locatetab">

	<!-- Header -->
	<h1 class="locate-page-header">
		<i class="fa fa-search" aria-hidden="true"></i> MONITOR ASSETS 
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block; padding: 0px 0px 15px 50px;">
			<button type="button" class="btn-sm btn-ef dropdown-toggle" data-toggle="dropdown">
				Saved List(s) <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li [class.disabled]="!isAnyAssetSelected() || isLoadingAssetList">
					<a (click)="onSaveCurrentListClicked()">SAVE CURRENT LIST</a>
				</li>
				<li *ngIf="isAnySavedStoredListItemPresent()" class="divider"></li>
				<li *ngFor="let assetList of storedAssetList" class="saved-asset-list-item" [class.disabled]="isLoadingAssetList">
					<a class="col-sm-9" (click)="onAssetListClicked(assetList)">{{ assetList?.name }}</a>
					<a class="col-sm-3" (click)="onDeleteClickedForStoredAssetList(assetList)"><em class="fa fa-remove"></em></a>
				</li>
			</ul>
		</div>
	</h1>

	<!-- Tab Navigation (People/Assets/Vehicles -->
	<ul class="nav nav-tabs">
		<li class="active">
			<a data-toggle="tab" href="#selectAssetsTab">
				SELECT ASSETS
			</a>
		</li>
		<li>
			<a data-toggle="tab" href="#selectedAssetsTab">
				SELECTED ASSETS <span> ({{ assetsSelected.length }}) [{{ getCountOfSelectedAssetsToBeDrawn() }}]</span>
			</a>
		</li>
	</ul>

	<!-- Tab Content (SELECT ASSETS / SELECTED ASSETS ) -->
	<div class="tab-content tab-section" style="border: 0px solid;">

		<!-- Select Assets Tab -->
		<div id="selectAssetsTab" class="tab-pane fade in active">

			<!-- Select Assets Tab - Search Bar -->
			<div class="input-group locate-input">
				<input style="width: 75%" class="form-control" placeholder="Search for Assets..." 
					#selectAssetsSearchInput [(ngModel)]="assetsToSelectSearchValue" [disabled]="isAssetsToSelectSearchOptionChanging || isLoadingAssetList">
				<select class="form-control" style="width: 25%" [(ngModel)]="selectedAssetsToSelectSearchOption" [disabled]="isSearchingAssetsToSelect || isLoadingAssetList" (change)="onAssetsToSelectSearchOptionChanged()">
					<option *ngFor="let searchOption of assetsToSelectSearchOptions" [ngValue]="searchOption">
						{{ (searchOption?.searchType == "NAME"? "NAME" : (searchOption?.property?.name + " (" + searchOption?.property?.object?.name) + ")") }}
					</option>
				</select>
			</div>

			<!-- Select Assets Tab - Pin Untagged Selections on Top Toggle -->
			<div style="font-size: small; padding: 6px 8px;">
				<span class="checkbox checkbox-inline">
					<input type="checkbox" class="styled" id="pinUntaggedSelectionsOnTopCheckbox"
						[(ngModel)]="pinUntaggedSelectionsOnTop">
					<label for="pinUntaggedSelectionsOnTopCheckbox">Show unfiltered selections on top</label>
				</span>
			</div>

			<!-- Select Assets Tab - Filter Tags -->
			<div *ngIf="filterTags.length > 0" class="filter-tags">
				<span *ngFor="let tag of filterTags" class="filter-tag" [class.active]="tag === activeFilterTag" (click)="onFilterTagClicked(tag)">
					{{ getFilterTagLabel(tag) }} ({{ tag.assetIds.length }})
					<em class="fa fa-remove filter-tag-cancel" title="Unselect these Assets" (click)="onFilterTagCancelClicked(tag, $event)"></em>
				</span>
			</div>

			<!-- Select Assets Tab - Viewing a Filter Tag's Search Results -->
			<div *ngIf="activeFilterTag" class="filter-tag-viewing-banner">
				Showing Assets matching <strong>{{ getFilterTagLabel(activeFilterTag) }}</strong> -
				<a (click)="onFilterTagClicked(activeFilterTag)">Clear Filter</a>
			</div>

			<!-- Select Assets Tab - Asset Information -->
			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Select Assets Tab Column Headers -->
					<tbody>
						<tr class="header">
							<th style="width: 0px">
								<div class="checkbox checkbox-inline">
									<input type="checkbox" class="styled"
										(click)="selectAllAssetsToSelect($event.target.checked)"
										[checked]="isAllAssetsToSelectSelected()"
										[disabled]="isSearchingAssetsToSelect || isSelectingAllAssetsToSelect || isLoadingAssetList">
									<label></label>
								</div>
							</th>
							<th>NAME</th>
						</tr>
					</tbody>

					<!-- Select Assets Data - Display Assets for selection -->
					<tbody id="locateTableLocations">

						<!-- If searching for Assets... Display a message indicating that.  -->
						<ng-container *ngIf="isSearchingAssetsToSelect; else selectAssetsListTemplate">
							<div>Searching&nbsp;Assets...</div>
						</ng-container>

						<!-- Assets are not being searched for... Display the loaded Assets -->
						<ng-template #selectAssetsListTemplate>
							<!-- Create the Assets to Select -->
							<ng-container *ngFor="let asset of getAssetsToSelectDisplayList() | paginate: {id: 'asset_pagination', itemsPerPage: assetsPerPage, currentPage: currentPage, totalItems: totalNumberOfAssets }">
								<tr class="locateHeader">
									<!-- Checkbox -->
									<td>
										<div class="checkbox checkbox-inline">
											<input type="checkbox" class="styled"
												(click)="onAssetToSelectToggled(asset, $event)"
												[disabled]="isSelectingAllAssetsToSelect || isAssetToSelectCheckboxBeingToggled(asset) || isLoadingAssetList"
												[checked]="isAssetToSelectSelected(asset)"
												>
											<label></label>
										</div>
									</td>
									<!-- Name -->
									<td>
										{{ asset?.name }}
										<span *ngIf="isAssetToSelectPinnedUntagged(asset)" class="pinned-untagged-label"> (selected, no filter)</span>
										<span *ngIf="isAssetToSelectSelectedUnderOtherFilter(asset)" class="selected-other-filter-label"> (already selected, {{ getAssetToSelectOtherFilterLabel(asset) }})</span>
									</td>
								</tr>
							</ng-container>
						</ng-template>
					</tbody>
				</table>
				</div>
				<!-- Pagination Controls for the "Asset" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="asset_pagination" (pageChange)="onPageChange($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>
			</div>
		</div>
		<!-- End of Select Assets Tab -->



		<!-- Selected Assets Tab -->
		<div id="selectedAssetsTab" class="tab-pane fade">

			<!-- Selected Assets Tab - Search Bar -->
			<div class="input-group locate-input">
				<input class="form-control" style="width: 75%; border: 0px solid;" placeholder="Search for something..." 
					#selectedAssetsSearchInput [(ngModel)]="selectedAssetsSearchValue" [disabled]="isSelectedAssetsSearchOptionChanging || isLoadingAssetList">
				<select class="form-control" style="width: 25%" [(ngModel)]="selectedAssetsSearchOption" [disabled]="isSearchingSelectedAssets || isLoadingAssetList" (change)="onSelectedAssetSearchOptionChanged()">
					<option *ngFor="let searchOption of assetsToSelectSearchOptions" [ngValue]="searchOption">
						{{ (searchOption?.searchType == "NAME"? "NAME" : (searchOption?.property?.name + " (" + searchOption?.property?.object?.name) + ")") }}
					</option>
				</select>
			</div>

			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Main Headers -->
					<tbody>
						<tr class="header">
							<th style="width: 0px;">
								<div class="checkbox checkbox-inline">
									<input type="checkbox" class="styled"
										(click)="selectAllSelectedAssets($event.target.checked)"
										[checked]="isAllSelectedAssetsSelected()"
										[disabled]="isSelectingAllSelectedAssets || isLoadingAssetList">
									<label></label>
								</div>
							</th>
							<th style="width: 0px;">ICON</th>
							<th>NAME</th>
							<th>LOCATION</th>
							<th>ZONE</th>
						</tr>
					</tbody>

					<!-- Selected Assets Tab Data -->
					<tbody id="locateTableAssets">

						<!-- If searching for Selected Assets... Display a message indicating that.  -->
						<ng-container *ngIf="isSearchingSelectedAssets || isSelectedAssetsSearchOptionChanging; else selectedAssetsTemplate">
							<div>Searching&nbsp;Selected&nbsp;Assets...</div>
						</ng-container>

						<!-- Selected Assets are not being searched for... Display the Selected Assets -->
						<ng-template #selectedAssetsTemplate>

							<!-- Create the Displays for each Asset -->
							<ng-container *ngFor="let asset of selectedAssetsToDisplay">

								<!-- Main Label (Displayed by default) -->
								<tr  class="locateHeader">
									<!-- Checkbox -->
									<td style="width: 16px">
										<div class="checkbox checkbox-inline">
											<input type="checkbox" class="styled" 
												(click)="onSelectedAssetToggled(asset, $event)"
												[disabled]="isSelectedAssetBeingToggled(asset) || isLoadingAssetList"
												[checked]="isSelectedAssetSelectedToBeDisplayed(asset)" >
											<label></label>
										</div>
									</td>

									<!-- Icon -->
									<td style="width: 16px" (click)="onSelectedListHeaderClicked(asset)">
										<img [src]="getIconSource(asset)" />
									</td>

									<!-- Name -->
									<td (click)="onSelectedListHeaderClicked(asset)">
										{{asset.name}}
									</td>

									<!-- Location -->
									<td (click)="onSelectedListHeaderClicked(asset)">
										{{asset.locationInstance?.name}}
									</td>

									<!-- Zone -->
									<td (click)="onSelectedListHeaderClicked(asset)">
										{{asset.zoneInstance?.name}}
									</td>
								</tr>

								<!-- Display Body-->
								<tr id="{{ getIdForSelectedListDisplayBody(asset) }}" class="locateBody hidden" style="background-color: #2f2f2f">
									<td colspan="5">
										<table style="background-color: #2f2f2f; border: 0; width: 100%">
											<tbody>
												<!-- Image (only added if present) -->
												<tr class="user-image" *ngIf="isImagePresent(asset)">
													<td rowspan="10">
														<img class="table-user-image" [src]="getImageSource(asset)" />
													</td>
												</tr>
												<!-- Description -->
												<tr class="user-list">
													<td>{{asset.description}}</td>
												</tr>
												<!-- Data for Main Display Properties (Main Display = TRUE) -->
												<ng-container *ngFor="let datum of asset.data">
													<ng-container *ngIf="datum.property.mainDisplay == true">
														<tr>
															<td>{{ datum.property.name }}:</td>
															<td style="max-width: 400px">
																<ng-container *ngIf="datum.property.type == 'STRING'">
																	<ng-container *ngIf="datum.property.parameter == 'url'">
																		<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																	</ng-container>
																	<ng-container *ngIf="datum.property.parameter != 'url'">
																		{{ datum.value }}
																	</ng-container>
																</ng-container>
																<ng-container *ngIf="datum.property.type != 'STRING'">
																	{{ datum.value }}
																</ng-container>
															</td>
														</tr>
													</ng-container>
												</ng-container>
												<!-- END OF: Data for Main Display Properties (Main Display = TRUE) -->
												
												<!-- Action(s) Button / "Full Details" Expand / Hide -->
												<tr>
													<td>
														<div class="dropdown btn-group" style="display:inline-block">
															<button type="button" class="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown">Action(s)</button>
															<ul class="dropdown-menu">
																<li (click)="openDataDialog(asset)"><a>Edit Data</a></li>
																<ng-container *ngIf="isContainsFunctions(asset)">
																	<li class="divider"></li>
																	<ng-container *ngFor="let assetFunction of asset?.object?.functions">
																		<li (click)="openFunctionDialog(asset, assetFunction?.key)"><a>{{ assetFunction?.name }}</a></li>
																	</ng-container>
																</ng-container>
															</ul>
														</div>
													</td>
													<td style="text-align: end; color:red;" class="locateBody">
														<ng-container *ngIf="isFullDetailsNeeded(asset)">
															<span id="{{getIdForSelectedListHideFullDetails(asset)}}" style="display: none;" (click)="hideSelectedListFullDetails(asset)"> - Hide Full Details </span>
															<span id="{{getIdForSelectedListShowFullDetails(asset)}}" (click)="showSelectedListFullDetails(asset)"> + Show Full Details </span>
														</ng-container>												
													</td>
												</tr>
												<!-- END OF: Action(s) Button / "Full Details" Expand / Hide -->

												<!-- Full Details Display -->
												<tr id="{{getIdForSelectedListFullDetails(asset)}}" class="locateBody" *ngIf="isFullDetailsNeeded(asset)"
													style="display: none; background-color: #2f2f2f" >
													<td colspan="5">
														<table style="background-color: #2f2f2f; border: 0; width: 100%">
															<tbody>
																<ng-container *ngFor="let datum of asset.data">
																	<ng-container *ngIf="datum.property.mainDisplay == false">
																		<tr>
																			<td>{{ datum.property.name }}:</td>
																			<td style="max-width: 400px">
																				<ng-container *ngIf="datum.property.type == 'STRING'">
																					<ng-container *ngIf="datum.property.parameter == 'url'">
																						<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																					</ng-container>
																					<ng-container *ngIf="datum.property.parameter != 'url'">
																						{{ datum.value }}
																					</ng-container>
																				</ng-container>
																				<ng-container *ngIf="datum.property.type != 'STRING'">
																					{{ datum.value }}
																				</ng-container>
																			</td>
																		</tr>
																	</ng-container>
																</ng-container>
															</tbody>
														</table>
													</td>
												</tr>
												<!-- END OF: Full Details Display-->
											</tbody>
										</table>
									</td>
								</tr>
							</ng-container>
						</ng-template>
					</tbody>
				</table>
				</div>
			</div>
		</div>
		<!-- End of Selected Assets Tab -->
	</div>
	<!-- End of Tabs Content -->
</div>
<!-- End of Left Hand Side -->

<!-- Right Hand Side -->
<div class="col-sm-9" style="margin: -10px 0 0 0; padding: 0; height: calc(100vh - 50px); overflow-y: hidden; background-image: url(assets/images/map_bg.png)">
	
	<!-- Display the available Locations to be the Map -->
	<div id="locationsWell" class="well" style="margin-bottom: 0; opacity: 0.8; border-right: 0px; border-left: 0px;">
		<ng-container *ngFor="let location of locationsToDisplay">
			<button type="button" class="btn" 
				[class.btn-primary]="location?.id == locationBeingDisplayed?.id" 
				[class.btn-secondary]="location?.id != locationBeingDisplayed?.id"
				(click)="onLocationClicked(location)"
				>
				{{ location?.name }} 
				<span class="badge badge-light badge-round"> {{ getSelectedAssetsInLocation(location).length }} </span>
			</button>
		</ng-container>
	</div>
	
	<!-- Map where everything is drawn -->
	<app-new-map #locateMap class="locate-map" 
		(onInstanceClicked)="onAssetClickedOnMap($event)"
		>
	</app-new-map>
</div><!-- end of col-sm-8 -->

<!-- Popup Dialog used to execute Function Action(s) on Assets -->
<ef-instance-function-popup
	(functionCompletedSuccessfullyEvent)="onFunctionCompletedSuccessfully($event)"
	>
</ef-instance-function-popup>

<!-- Popup Dialog used execute the "Edit Data" Action on Assets -->
<ef-instance-data-dialog
	(updateCompletedSuccessfullyEvent)="onDataUpdatedSuccessfully($event)"
	>
</ef-instance-data-dialog>

<!-- Popup Dialogs for each tracked instances  -->
<ng-container *ngFor="let asset of getSelectedAssetsInLocation(locationBeingDisplayed)">
	<ef-instance-locate-popup
		[instance]="asset"
		[dialogId]="getIdForPopup(asset)"
		[hideEmitter]="getHideEmitter(asset)"
		>
	</ef-instance-locate-popup>
</ng-container>

<!-- Save Asset List Dialog -->
<ef-save-asset-list-dialog
	(saveClicked)="onSaveAssetListDialogSaveClicked($event)"
	(cancelClicked)="onSaveAssetListDialogCancelClicked()"
	>	
</ef-save-asset-list-dialog>

<!-- Simple Confirm Dialog used to confirm deletions from the Stored Asset List -->
<ef-simple-confirm-dialog
	(confirmClicked)="onConfirmDialogConfirmClicked()"
	(cancelClicked)="onConfirmDialogCancelClicked()"
	>
</ef-simple-confirm-dialog>

<!-- Success/Error Dialog used to notify the User of things like the Selection Limit being reached -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>